 // Función para validar el RUT chileno
 export const validateRUT = (rut: string): boolean => {
    // Limpiar el RUT de puntos y guiones, y convertir el DV a mayúsculas
    const cleanRUT = rut.replace(/[^\dkK]/g, '').toUpperCase();

    // El RUT debe tener al menos 2 caracteres (números + dígito verificador)
    if (cleanRUT.length < 2) return false;

    // Extraer el número y el dígito verificador
    const rutNumber = cleanRUT.slice(0, -1); // Todo menos el último carácter (el DV)
    const dv = cleanRUT.slice(-1); // Último carácter (el DV)

    // Asegurarse de que el número del RUT sea un número
    if (!/^\d+$/.test(rutNumber)) return false;

    // Convertir el número del RUT en un array de dígitos
    const reverseRut = Array.from(rutNumber).reverse().map(Number);

    let factor = 2;
    let total = 0;

    reverseRut.forEach((digit) => {
        total += digit * factor;
        factor = factor === 7 ? 2 : factor + 1;
    });

    // Calcular el dígito verificador esperado
    const calculatedDV = 11 - (total % 11);
    const expectedDV = calculatedDV === 11 ? '0' : calculatedDV === 10 ? 'K' : calculatedDV.toString();

    // Comparar el dígito verificador calculado con el proporcionado
    return dv === expectedDV;
};

export const formatRUT = (rut: string): string => {
    // Remover puntos y guion
    let cleanRut = rut.replace(/[^\dkK]/g, ''); 
    if (cleanRut.length > 1) {
        // Agregar guion antes del dígito verificador
        cleanRut = `${cleanRut.slice(0, -1)}-${cleanRut.slice(-1)}`;
    }
    return cleanRut;
};

export const validateDNI = (dni: string): boolean => {
    const dniRegex = /^\d{8}[A-Z]$/; // El formato debe ser 8 dígitos y una letra
    if (!dniRegex.test(dni)) return false;

    const numberPart = parseInt(dni.slice(0, 8), 10); // Obtener la parte numérica
    const letterPart = dni.slice(-1); // Obtener la letra

    const validLetters = 'TRWAGMYFPDXBNJZSQVHLCKE'; // Tabla de letras válidas
    const correctLetter = validLetters[numberPart % 23]; // Calcular la letra correcta

    return correctLetter === letterPart; // Verificar si la letra es correcta
};
